import { HotelIcon, HouseIcon } from "../../board/BuildingIcons";

/** Houses (1-4) or the hotel (5) of a street, with a text label for screen readers. */
export function Buildings({ count, size = 18 }: { count: number; size?: number }) {
  if (count <= 0) return null;
  const label = count === 5 ? "Hotel" : count === 1 ? "1 Haus" : `${count} Häuser`;
  return (
    <span role="img" aria-label={label} title={label} className="inline-flex items-center gap-0.5">
      {count === 5 ? <HotelIcon size={size + 4} /> : Array.from({ length: count }, (_, i) => <HouseIcon key={i} size={size} />)}
    </span>
  );
}
